import { Box, InputLabel, TextField, TextFieldProps } from "@mui/material";
import { ReactNode } from "react";

export function LabeledInput(
  props: TextFieldProps & {
    endAdornment?: ReactNode;
    customHeight?: number;
    disablePaste?: boolean;
  }
) {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"flex-start"}
      width={"100%"}
      my={1}
    >
      <InputLabel style={{ fontSize: "13px" }}>{props.label}</InputLabel>
      <TextField
        {...props}
        label={null}
        onPaste={(e) => {
          if (props.disablePaste) {
            e.preventDefault();
          }
          props.onPaste?.(e);
        }}
        InputProps={{
          endAdornment: props.endAdornment || null,
        }}
        sx={{
          ...(props.customHeight && {
            "& .MuiInputBase-root": {
              height: props.customHeight,
            },
          }),

          "& .MuiOutlinedInput-root.Mui-disabled": {
            overflow: "hidden",
            "& fieldset": {
              border: "1px solid rgba(0,0,0,0.2)",
              borderRadius: "4px",
            },
          },

          "& .MuiInputBase-inputMultiline": {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          },
        }}
      />
    </Box>
  );
}
